import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import { IUpdateBroadcastTextStatusRequest } from "./request.types";
import type {
	TGetBroadcastStatusResponse,
	TPostStartBroadcastResponse,
	getBroadcastSettingsResponse,
} from "./response.types";

class BroadcastController extends Controller {
	public constructor() {
		super({ requestUrl: "models/broadcast/" });
	}

	/**@GET BROADCAST STATUS */
	public async broadcastStatusAsync({ token }: IRequestConfig) {
		return this.get<TGetBroadcastStatusResponse>("base", "check", { token });
	}

	/**@POST UPDATE TEXT STATUS */
	public async updateBroadcastTextStatus({ token, correlationId, status }: IUpdateBroadcastTextStatusRequest) {
		return this.post<void>("updateTextStatus", { correlationId, status }, { token });
	}

	/**@POST START BROADCAST */
	public async startBroadcastAsync({ token }: IRequestConfig) {
		return this.post<TPostStartBroadcastResponse>("start", null, { token });
	}

	/**@POST STOP BROADCAST */
	public async stopBroadcastAsync({ token }: IRequestConfig) {
		return this.post<void>("stop", null, { token });
	}

	/**@POST START AWAY MODE */
	public async startAwayModeAsync({ token }: IRequestConfig) {
		return this.post<void>("away/start", null, { token });
	}

	/**@POST STOP AWAY MODE */
	public async stopAwayModeAsync({ token }: IRequestConfig) {
		return this.post<void>("away/stop", null, { token });
	}

	/**@GET GET BROADCAST SETTINGS */
	public async getBroadcastSettingsAsync({ token }: IRequestConfig) {
		return this.get<getBroadcastSettingsResponse>("base", "settings", { token });
	}
}

export const broadcastAPI = new BroadcastController();
